import styled from "@emotion/styled";

const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 59px;
  gap: 15px;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-areas:
    "header header header"
    ". . searchOne"
    ". . searchTwo";

  gap: 30px;
  margin-bottom: 10px;

  .head {
    grid-area: header;
  }
  .searchfieldPermissions {
    grid-area: searchOne;
  }
  .searchfieldRole {
    grid-area: searchTwo;
  }
`;

export default { CheckboxWrapper, TitleWrapper, GridContainer };
